import React, { useState, useEffect } from 'react'
import '../css/layout.css'
import '../css/homepage.css'
import css from '../css/with.css'
import axios from 'axios'
import { Link, useHistory } from 'react-router-dom'
import Swal from 'sweetalert2'
import '../css/Loader.css'
// import findGif from "../css/loading.gif";
import findGif from '../css/loading_old.gif'
import io from '../Components/socket'
import Header from '../Components/Header'

const Withdrawopt = ({ walletUpdate }) => {
  const history = useHistory()

  const access_token = localStorage.getItem('token')
  const [Id, setId] = useState(null)
  const [user, setUser] = useState()
  const [holder_name, setHolder_name] = useState()
  const [bank_name, setBank_name] = useState()
  const [account_number, setAccount_number] = useState()
  const [paytmNumber, setpaytmNumber] = useState()

  const [confirm_account_number, setConfirm_account_number] = useState()
  const [ifsc_code, setIfsc_code] = useState()
  const [upi_id, setUpi_id] = useState()
  const [confirm_upi_id, setConfirm_upi_id] = useState()
  const [next, setNext] = useState(false)

  const [isCashFreePayoutActive, setCashFreePayoutActive] = useState(false)
  const [isRazorPayPayoutActive, setRazorPayPayoutActive] = useState(false)
  const [isDecentroPayoutActive, setDecentroPayoutActive] = useState(false)

  const [isRazorPayPayoutAuto, setRazorPayPayoutAuto] = useState(false)
  const [isDecentroPayoutAuto, setDecentroPayoutAuto] = useState(false)
  const [maxAutopayAmt, setMaxAutopayAmt] = useState(0)

  const [submitBtn, setSubmitBtn] = useState(true)
  const [withdrawal, setWithdrawal] = useState(true)
  const [Upiwithdrawal, setUpiWithdrawal] = useState(true)
  const [Bankwithdrawal, setBankWithdrawal] = useState(true)
  const [paytmwithdrawal, setpaytmWithdrawal] = useState(true)

  const [minLimit, setMinLimit] = useState(null)
  const [maxLimit, setMaxLimit] = useState(null)
  const [isLoading, setIsloading] = useState(false)
  const [qrImage, setQrImage] = useState(null)

  // console.log(maxLimit,"maxLimit",minLimit)
  const [type, setType] = useState(undefined)
  const [mount, setMount] = useState(false)

  useEffect(() => {
    const addsetting = localStorage.getItem('sitSetting')
    const addCaseSetting = JSON.parse(addsetting)
    setWithdrawal(addCaseSetting?.isWithdrawal)
    setUpiWithdrawal(addCaseSetting?.isUpiWithdrawal)
    setBankWithdrawal(addCaseSetting?.isBankWithdrawal)
    setMinLimit(addCaseSetting?.withdrawalLimitMin)
    setMaxLimit(addCaseSetting?.withdrawalLimitMax)
  })

  useEffect(() => {
    let access_token = localStorage.getItem('token')
    const headers = {
      Authorization: `Bearer ${access_token}`
    }

    axios
      .get(`https://api.kakaking.in/me`, { headers })
      .then(res => {
        setUser(res.data)
        // console.log(res.data);
        setId(res.data._id)
        setHolder_name(res.data.holder_name)
        setBank_name(res.data.bank_name)
        setAccount_number(res.data.account_number)
        setConfirm_account_number(res.data.confirm_account_number)
        setIfsc_code(res.data.ifsc_code)
        setUpi_id(res.data.upi_id)
        setConfirm_upi_id(res.data.confirm_upi_id)
      })
      .catch(e => {
        if (e.response.status == 401) {
          localStorage.removeItem('token')
          localStorage.removeItem('token')
          window.location.reload()
          history.push('/login')
        }
      })

    axios
      .get(`https://api.kakaking.in/website/setting`)
      .then(res => {
        //console.log(res);
        setCashFreePayoutActive(res.data.isCashFreePayoutActive)
        setRazorPayPayoutActive(true)
        setDecentroPayoutActive(res.data.isDecentroPayoutActive)

        setRazorPayPayoutAuto(res.data.isRazorPayPayoutAuto)
        setDecentroPayoutAuto(res.data.isDecentroPayoutAuto)
        setMaxAutopayAmt(res.data.maxAutopayAmt)
        setpaytmWithdrawal(res.data?.ispaytmWithdrawal)
      })
      .catch(e => {
        setCashFreePayoutActive(false)
        setRazorPayPayoutActive(false)
        setDecentroPayoutActive(false)
        setMaxAutopayAmt(0)
      })
  }, [])

  const handleIfscChange = e => {
    const inputValue = e.target.value
    if (inputValue.length <= 11) {
      setIfsc_code(inputValue)
    }
  }
  const updateBankDetails = async () => {
    setIsloading(true)

    setMount(true)
    setSubmitBtn(false)
    // e.preventDefault();
    if (amount < minLimit || amount > maxLimit) {

      Swal.fire({
        title: 'Invalid Amount',
        text: `Minimum withdraw ${ minLimit} and Maximum withdraw ₹${maxLimit} allowed.`,
        icon: 'error',
        confirmButtonText: 'OK'
      });

      setIsloading(false);
      setSubmitBtn(true);
      return;
    }
    if (type === 'upi') {
      let regex = /^[\w.-]+@[\w.-]+$/.test(upi_id)

      if (regex) {
        if (upi_id === confirm_upi_id) {
          Swal.fire({
            title: `Is your UPI ID correct? ${upi_id}`,
            icon: 'success',
            confirmButtonText: 'OK'
          })

          const access_token = localStorage.getItem('token')
          const headers = {
            Authorization: `Bearer ${access_token}`
          }

          setIsloading(true)
          const data = await axios
            .patch(
              `https://api.kakaking.in/user/edit`,
              {
                holder_name,
                type,
                account_number,
                confirm_account_number,
                ifsc_code,
                upi_id,
                bankDetails: true
              },
              { headers }
            )
            .then(res => {
              setIsloading(false)
              // console.log('updata bank details', res)
              if (res.data.subCode === '200') {
                // console.log(res.data)
                let calculatedWallet =
                  user.wonAmount -
                  user.loseAmount +
                  user.totalDeposit +
                  user.referral_earning +
                  user.hold_balance +
                  user.totalBonus -
                  (user.totalWithdrawl +
                    user.referral_wallet +
                    user.totalPenalty)

                withReqComes()
              } else {
                setMount(false)
                setSubmitBtn(true)
                Swal.fire({
                  title: res.data.msg,
                  icon: 'error',
                  confirmButtonText: 'OK'
                })
              }
            })
            .catch(e => {
              console.log(e)
              setMount(false)
              if (e.response.status == 401) {
                localStorage.removeItem('token')
                localStorage.removeItem('token')
                window.location.reload()
                history.push('/login')
              }
            })
        } else {
          Swal.fire({
            title: 'UPI IDs do not match',
            text: 'Please make sure your UPI IDs match',
            icon: 'error',
            confirmButtonText: 'OK'
          })

          setSubmitBtn(true)
        }
      } else {
        Swal.fire({
          title: `Invalid UPI ID: ${upi_id}`,
          text: 'Please enter a valid UPI ID',
          icon: 'error',
          confirmButtonText: 'OK'
        })
        setSubmitBtn(true)
      }
    } else if (type === 'banktransfer') {
      const access_token = localStorage.getItem('token')
      const headers = {
        Authorization: `Bearer ${access_token}`
      }

      setIsloading(true)
      const data = await axios
        .patch(
          `https://api.kakaking.in/user/edit`,
          {
            holder_name,
            type,
            account_number,
            confirm_account_number,
            ifsc_code,
            upi_id,
            bankDetails: true
          },
          { headers }
        )
        .then(res => {
          setIsloading(false)
          // console.log('updata bank details', res)
          if (res.data.subCode === '200') {
            // console.log(res.data)
            let calculatedWallet =
              user.wonAmount -
              user.loseAmount +
              user.totalDeposit +
              user.referral_earning +
              user.hold_balance +
              user.totalBonus -
              (user.totalWithdrawl + user.referral_wallet + user.totalPenalty)

            calculatedWallet == user.Wallet_balance
              ? doAutoPayout()
              : withReqComes()
          } else {
            setMount(false)
            setSubmitBtn(true)
            Swal.fire({
              title: res.data.msg,
              icon: 'error',
              confirmButtonText: 'OK'
            })
          }
        })
        .catch(e => {
          console.log(e)
          setMount(false)
          if (e.response.status == 401) {
            localStorage.removeItem('token')
            localStorage.removeItem('token')
            window.location.reload()
            history.push('/login')
          }
        })
    } else if (type === 'paytmransfer') {
      const access_token = localStorage.getItem('token')
      const headers = {
        Authorization: `Bearer ${access_token}`
      }
      const data = await axios
        .patch(
          `https://api.kakaking.in/user/edit`,
          {
            holder_name,
            paytmNumber
          },
          { headers }
        )
        .then(res => {
          setIsloading(false)
          // console.log('updata bank details', res)
          if (res.data.subCode === '200') {
            // console.log(res.data)
            let calculatedWallet =
              user.wonAmount -
              user.loseAmount +
              user.totalDeposit +
              user.referral_earning +
              user.hold_balance +
              user.totalBonus -
              (user.totalWithdrawl + user.referral_wallet + user.totalPenalty)

            calculatedWallet == user.Wallet_balance
              ? doAutoPayout()
              : withReqComes()
          } else {
            setMount(false)
            setSubmitBtn(true)
            Swal.fire({
              title: res.data.msg,
              icon: 'error',
              confirmButtonText: 'OK'
            })
          }
        })
        .catch(e => {
          console.log(e)
          setMount(false)
          if (e.response.status == 401) {
            localStorage.removeItem('token')
            localStorage.removeItem('token')
            window.location.reload()
            history.push('/login')
          }
        })
    } else if (type === 'scannerpayment') {
      setIsloading(false)
      withReqComes();
    }
    else {
      setMount(false)
      setSubmitBtn(true)
    }
  }
  const [siteSetting, setsiteSetting] = useState([])
  useEffect(() => {
    const items = JSON.parse(localStorage.getItem('sitSetting'))
    if (items) setsiteSetting(items)
  }, [])
  const [amount, setAmount] = useState()

  const doAutoPayout = () => {
    if (isRazorPayPayoutAuto && type == 'upi') {
      if (amount <= maxAutopayAmt) {
      } else {
        withReqComes()
      }
    } else if (isDecentroPayoutAuto && type == 'banktransfer') {
      withReqComes()
    } else if (type == 'scannerpayment') {
      withReqComes()
    }
    else {
      withReqComes()
    }
  }



  // const withReqComes = async () => {
  //   try {
  //     setMount(true)

  //     if (type == 'upi') {
  //       var payment_gatway = 'razorpay'
  //     } else {
  //       var payment_gatway = 'decentro'
  //     }

  //     const access_token = localStorage.getItem('token')
  //     const headers = {
  //       Authorization: `Bearer ${access_token}`
  //     }

  //     if (amount > maxLimit) {
  //       Swal.fire({
  //         title: 'Invalid amount',
  //         text: 'Please enter an amount within the allowed limits.',
  //         icon: 'error',
  //         confirmButtonText: 'OK'
  //       })
  //     } else {
  //       setMount(true)
  //       await axios
  //         .post(
  //           `https://api.kakaking.in/withdraw/request`,
  //           {
  //             amount,
  //             type,
  //             payment_gatway
  //           },
  //           { headers }
  //         )
  //         .then(res => {
  //           if (res.data.success) {
  //             setMount(false)

  //             Swal.fire({
  //               title: res?.data?.msg,
  //               icon: 'success',
  //               confirmButtonText: 'OK'
  //             })
  //             history.push('/')
  //           } else {
  //             Swal.fire({
  //               title: res.data.msg,
  //               icon: 'error',
  //               confirmButtonText: 'OK'
  //             })
  //           }

  //           setMount(false)
  //         })
  //         .catch(e => {
  //           console.log(e)
  //           setMount(false)
  //         })
  //     }
  //   } catch (error) {
  //     console.log(error)
  //   }
  // }
  const withReqComes = async () => {
    try {
      setMount(true);

      let payment_gatway = type === "upi" ? "razorpay" : "decentro";

      const access_token = localStorage.getItem("token");
      const headers = {
        Authorization: `Bearer ${access_token}`,
      };

      if (amount > maxLimit) {
        setMount(false);
        return Swal.fire({
          title: "Invalid amount",
          text: "Please enter an amount within the allowed limits.",
          icon: "error",
          confirmButtonText: "OK",
        });
      }

      /* 🔴 SCANNER PAYMENT */
      if (type === "scannerpayment") {
        if (!qrImage) {
          setMount(false);
          return Swal.fire({
            title: "QR Required",
            text: "Please upload QR code",
            icon: "error",
          });
        } else if (amount > 2000) {
          setMount(false);
          return Swal.fire({
            title: "Valid Amount Enter",
            text: "Enter Amount Should Be less than 2000",
            icon: "error",
          });
        }

        const formData = new FormData();
        formData.append("amount", amount);
        formData.append("type", type);
        formData.append("payment_gatway", payment_gatway);
        formData.append("qr", qrImage);

        const res = await axios.post(
          "https://api.kakaking.in/withdraw/request",
          formData,
          { headers }
        );

        if (res.data.success) {
          Swal.fire({
            title: res.data.msg,
            icon: "success",
          });
          history.push("/");
        } else {
          Swal.fire({
            title: res.data.msg,
            icon: "error",
          });
        }

        setMount(false);
        return;
      }

      /* 🔵 NORMAL (UPI / BANK) */
      const res = await axios.post(
        "https://api.kakaking.in/withdraw/request",
        {
          amount,
          type,
          payment_gatway,
        },
        { headers }
      );

      if (res.data.success) {
        Swal.fire({
          title: res.data.msg,
          icon: "success",
        });
        history.push("/");
      } else {
        Swal.fire({
          title: res.data.msg,
          icon: "error",
        });
      }

      setMount(false);
    } catch (error) {
      console.log(error);
      setMount(false);
      Swal.fire("Error", "Something went wrong", "error");
    }
  };






  return (
    <>
      <div
        className='leftContainer mb_space'
        style={{ minHeight: '100vh', height: '100%' }}
      >
        <div className='container px-3 mt-5 py-5' style={{ height: '10px' }}>
          <div className='row'>
            <div className='col mx-auto'>
              <div className='mt-3'>
                <div className="site_message_main">
                  <p>{siteSetting?.rk1g}</p>
                </div>
                {user && user?.verified === 'verified' ? (
                <div className=' '>
                  <h4 className='pt-1 profile_headings '>
                    {type == undefined
                      ? 'Choose withdrawal option'
                      : 'Withdraw through'}
                  </h4>
                  {Boolean(!next) && (
                    <div>
                      {/* upi id */}
                      {Upiwithdrawal === true
                        ? Boolean(isRazorPayPayoutActive) && (
                          <div
                            onClick={() => {
                              setType('upi')
                              setNext(true)
                            }}
                            className='add-fund-box my-3'

                          >
                            <div
                              className='d-flex align-items-center profile_info_small_box_main bank_page_cards mt-4'
                              style={{ minHeight: 'auto' }}
                            >
                              <div className='d-flex align-items-center'>
                                <img
                                  width='45px'
                                  src={process.env.PUBLIC_URL + '/UPI.png'}
                                  alt=''
                                  style={{
                                    marginLeft: '7px',
                                    paddingBottom: '10px',
                                    paddingLeft: '3px',
                                    paddingTop: '5px'
                                  }}
                                />
                              </div>
                              <div className='d-flex justify-content-center flex-column ml-4'>
                                <div className='text-left'>
                                  <h3 style={{ fontWeight: '500' }}>
                                    Withdraw through UPI
                                  </h3>
                                  <ul>
                                    <li>
                                      Minimum withdrawal amount {minLimit}
                                    </li>
                                    <li>
                                      Instant withdrawal within 30sec.
                                    </li>
                                  </ul>
                                </div>
                                <div className='jss31'></div>
                              </div>
                            </div>
                          </div>
                        )
                        : ''}
                      {/* bank account number */}
                      {Bankwithdrawal === true
                        ? Boolean(isRazorPayPayoutActive) && (
                          <div
                            onClick={() => {
                              setType('banktransfer')
                              setNext(true)
                            }}
                            className='add-fund-box my-3'
                          // style={{ paddingTop: '0px', height: '60px' }}
                          >
                            <div
                              className='d-flex align-items-center profile_info_small_box_main bank_page_cards'
                              style={{ minHeight: 'auto' }}
                            >
                              <div
                                className='d-flex align-items-center'

                              >
                                <img
                                  width='45px'
                                  src='../images/Bank.png'
                                  alt=''
                                  style={{
                                    marginLeft: '7px',
                                    paddingBottom: '10px',
                                    paddingLeft: '3px',
                                    paddingTop: '5px'
                                  }}
                                />
                              </div>
                              <div className='d-flex justify-content-center flex-column ml-4'>
                                <div className='text-left'>
                                  <h3 style={{ fontWeight: '500' }}>
                                    Bank Transfer
                                  </h3>
                                  <ul>
                                    <li>
                                      Minimum withdrawal amount {minLimit}
                                    </li>
                                    <li>
                                      Instant withdrawal within 30sec.
                                    </li>
                                  </ul>
                                </div>
                                <div className='jss31'></div>
                              </div>
                            </div>
                          </div>
                        )
                        : ''}

                      {/* SCANNER PAYMENT */}

                      {Upiwithdrawal === true
                        ? Boolean(isRazorPayPayoutActive) && (

                          <div
                            onClick={() => {
                              setType("scannerpayment")
                              setNext(true)
                            }}
                            className="add-fund-box my-3"
                          >
                            <div className="d-flex align-items-center profile_info_small_box_main bank_page_cards">
                              <div className="d-flex align-items-center">
                                <img
                                  width="45px"
                                  src="/images/qrcode.webp"
                                  alt="QR"
                                  style={{ marginLeft: "7px", padding: "5px" }}
                                />
                              </div>
                              <div className="d-flex justify-content-center flex-column ml-4">
                                <h3 style={{ fontWeight: "500" }}>
                                  Withdraw through Scanner
                                </h3>
                                <ul>
                                  <li>Upload QR & enter amount</li>
                                  <li>Manual verification</li>
                                </ul>
                              </div>
                            </div>
                          </div>)
                        : ''}



                      {paytmwithdrawal === true
                        ? Boolean(isRazorPayPayoutActive) && (
                          <div
                            onClick={() => {
                              setType('paytmransfer')
                              setNext(true)
                            }}
                            className='add-fund-box my-3'

                          >
                            <div
                              className='d-flex align-items-center profile_info_small_box_main bank_page_cards'
                              style={{ minHeight: 'auto' }}
                            >
                              <div
                                className='d-flex align-items-center'

                              >
                                <img
                                  width='45px'
                                  src='../images/icons/paytm.png'
                                  alt=''
                                  style={{
                                    marginLeft: '7px',
                                    paddingBottom: '10px',
                                    paddingLeft: '3px',
                                    paddingTop: '5px'
                                  }}
                                />
                              </div>
                              <div className='d-flex justify-content-center flex-column ml-4'>
                                <div className='text-left'>
                                  <h3 style={{ fontWeight: '500' }}>
                                    Paytm Transfer
                                  </h3>
                                  <ul>
                                    <li>
                                      Minimum withdrawal amount {minLimit}
                                    </li>
                                    <li>
                                      Instant withdrawal within 30sec.
                                    </li>
                                  </ul>
                                </div>
                                <div className='jss31'></div>
                              </div>
                            </div>
                          </div>
                        )
                        : ''}
                    </div>
                  )}

                  {Boolean(next) && (
                    <div>
                      <div className='row bg-light p-1'>
                        <div
                          className='text-left w-100'
                          style={{ background: 'white' }}
                        >

                          {Boolean(
                            isRazorPayPayoutActive || isCashFreePayoutActive
                          ) &&
                            Boolean(type == 'upi') && (
                              <div className='add-fund-box my-3'>
                                <div
                                  className='d-flex align-items-center profile_info_small_box_main bank_page_cards'
                                  style={{ minHeight: 'auto' }}
                                >
                                  <div className='d-flex align-items-center '>
                                    <img
                                      width='45px'
                                      src={
                                        process.env.PUBLIC_URL + '/UPI.png'
                                      }
                                      alt=''
                                      style={{
                                        marginLeft: '7px',
                                        paddingBottom: '10px',
                                        paddingLeft: '3px',
                                        paddingTop: '5px'
                                      }}
                                    />
                                  </div>
                                  <div className='d-flex justify-content-center flex-column ml-4'>
                                    <div className='text-left'>
                                      <h3 style={{ fontWeight: '500' }}>
                                        Withdraw through UPI
                                      </h3>

                                      <ul>
                                        <li>
                                          Minimum withdrawal amount {minLimit}
                                        </li>
                                        <li>
                                          Instant withdrawal within 30sec.
                                        </li>
                                      </ul>
                                    </div>
                                    <div className='jss31'></div>
                                  </div>
                                  <button
                                    onClick={() => {
                                      setNext(false)
                                    }}
                                    className='btn btn-info text-white font-weight-bold ml-auto mr-3 '
                                    style={{ fontSize: '0.5rem' }}
                                  >
                                    Edit
                                  </button>
                                </div>
                              </div>
                            )}
                          {/* bank account number */}
                          {Boolean(isRazorPayPayoutActive) &&
                            Boolean(type == 'banktransfer') && (
                              <div className='add-fund-box my-3 '>
                                <div
                                  className='d-flex align-items-center profile_info_small_box_main bank_page_cards'
                                  style={{ minHeight: 'auto' }}
                                >
                                  <div className='d-flex align-items-center'>
                                    <img
                                      width='45px'
                                      src='../images/Bank.png'
                                      alt=''
                                      style={{
                                        marginLeft: '7px',
                                        paddingBottom: '10px',
                                        paddingLeft: '3px',
                                        paddingTop: '5px'
                                      }}
                                    />
                                  </div>
                                  <div className='d-flex justify-content-center flex-column ml-4'>
                                    <div className='text-left'>
                                      <h3 style={{ fontWeight: '500' }}>
                                        Bank Transfer
                                      </h3>

                                      <ul>
                                        <li>
                                          Minimum withdrawal amount {minLimit}
                                        </li>
                                        <li>
                                          Instant withdrawal within 30sec.
                                        </li>
                                      </ul>
                                    </div>
                                    <div className='jss31'></div>
                                  </div>
                                  <button
                                    onClick={() => {
                                      setType(undefined)
                                      setNext(false)
                                      console.log(type)
                                    }}
                                    className='btn btn-info text-white font-weight-bold ml-auto mr-3'
                                    style={{ fontSize: '0.5rem' }}
                                  >
                                    Edit
                                  </button>
                                </div>
                              </div>
                            )}



                          {(isRazorPayPayoutActive || isCashFreePayoutActive) &&
                            type === "scannerpayment" && (
                              <div className="add-fund-box my-3">
                                <div
                                  className="d-flex align-items-center profile_info_small_box_main bank_page_cards"
                                  style={{ minHeight: "auto" }}
                                >
                                  <div className="d-flex align-items-center">
                                    <img
                                      width="45px"
                                      src="../images/qrcode.webp"
                                      alt="Bank"
                                      style={{
                                        marginLeft: "7px",
                                        paddingBottom: "10px",
                                        paddingLeft: "3px",
                                        paddingTop: "5px",
                                      }}
                                    />
                                  </div>

                                  <div className="d-flex justify-content-center flex-column ml-4">
                                    <div className="text-left">
                                      <h3 style={{ fontWeight: 500 }}>Scanner Transfer</h3>

                                      <ul>
                                        <li>Minimum withdrawal amount {minLimit}</li>
                                        <li>Instant withdrawal within 30 sec.</li>
                                      </ul>
                                    </div>
                                    <div className="jss31"></div>
                                  </div>

                                  <button
                                    onClick={() => {
                                      setType(undefined);
                                      setNext(false);
                                    }}
                                    className="btn btn-info text-white font-weight-bold ml-auto mr-3"
                                    style={{ fontSize: "0.5rem" }}
                                  >
                                    Edit
                                  </button>
                                </div>
                              </div>
                            )}


                          {/* paytm number */}
                          {Boolean(isRazorPayPayoutActive) &&
                            Boolean(type == 'paytmransfer') && (
                              <div className='add-fund-box my-3 p-2'>
                                <div
                                  className='d-flex align-items-center profile_info_small_box_main bank_page_cards'
                                  style={{ minHeight: 'auto' }}
                                >
                                  <div className='d-flex align-items-center'>
                                    <img
                                      width='45px'
                                      src='../images/icons/paytm.png'
                                      alt=''
                                      style={{
                                        marginLeft: '7px',
                                        paddingBottom: '10px',
                                        paddingLeft: '3px',
                                        paddingTop: '5px'
                                      }}
                                    />
                                  </div>
                                  <div className='d-flex justify-content-center flex-column ml-4 '>
                                    <div className='text-left'>
                                      <h3 style={{ fontWeight: '500' }}>
                                        Paytm Transfer
                                      </h3>

                                      <ul>
                                        <li>
                                          Minimum withdrawal amount {minLimit}
                                        </li>
                                        <li>
                                          Instant withdrawal within 30sec.
                                        </li>
                                      </ul>
                                    </div>
                                    <div className='jss31'></div>
                                  </div>
                                  <button
                                    onClick={() => {
                                      setType(undefined)
                                      setNext(false)
                                    }}
                                    className='btn btn-info text-white font-weight-bold ml-auto mr-3'
                                    style={{ fontSize: '0.5rem' }}
                                  >
                                    Edit
                                  </button>
                                </div>
                              </div>
                            )}

                          <div className='mt-5 p-3'>
                            {/* bank account number */}
                            {Boolean(isRazorPayPayoutActive) &&
                              type == 'banktransfer' && (
                                <div className=''>
                                  <div>
                                    <label
                                      htmlFor='username '
                                      className='mr-5 commaon_label'
                                      style={{ color: '#d28d01' }}
                                    >
                                      <i className='far fa-user mr-2'></i>
                                      Account holder name (खाता धारक का नाम)
                                    </label>
                                    <div className='col-12 mb-3 p-0'>
                                      <input
                                        type='text'
                                        className='form-control'
                                        id='account_no'
                                        placeholder='Enter Account Name'
                                        name='ifsc'
                                        value={holder_name}
                                        onChange={e =>
                                          setHolder_name(e.target.value)
                                        }
                                        required
                                      />
                                    </div>
                                  </div>

                                  <div>
                                    <label
                                      htmlFor='username '
                                      className='mr-5 commaon_label'
                                      style={{ color: '#d28d01' }}
                                    >
                                      <i className='far fa-bank mr-2'></i>
                                      Account number (खाता संख्या):
                                    </label>
                                    <div className='col-12 mb-3 p-0'>
                                      <input
                                        type='text'
                                        className='form-control'
                                        id='account_no'
                                        placeholder='Enter your bank account number'
                                        name='upi'
                                        value={account_number}
                                        onChange={e =>
                                          setAccount_number(e.target.value)
                                        }
                                      />
                                    </div>
                                    <label
                                      htmlFor='username '
                                      className='mr-5 commaon_label'
                                      style={{ color: '#d28d01' }}
                                    >
                                      <i className='far fa-bank mr-2'></i>{' '}
                                      Confirm Account number (कन्फर्म खाता
                                      संख्या) :
                                    </label>
                                    <div className='col-12 mb-3 p-0'>
                                      <input
                                        type='text'
                                        className='form-control commaon_input_box'
                                        id='account_no'
                                        placeholder='Re Enter Your Bank Account Number'
                                        name='ifsc'
                                        value={confirm_account_number}
                                        onChange={e =>
                                          setConfirm_account_number(
                                            e.target.value
                                          )
                                        }
                                      />
                                    </div>
                                  </div>
                                  <div>
                                    <label
                                      htmlFor='username '
                                      className='mr-5 commaon_label'
                                      style={{ color: '#d28d01' }}
                                    >
                                      <i className='far fa-bank mr-2'></i>
                                      IFSC code (IFSC कोड ) :
                                    </label>
                                    <div className='col-12 mb-3 p-0'>
                                      <input
                                        type='text'
                                        className='form-control'
                                        id='account_no'
                                        placeholder='Enter IFSC code'
                                        name='ifsc'
                                        value={ifsc_code}
                                        onChange={handleIfscChange}
                                      />
                                    </div>
                                  </div>
                                </div>
                              )}
                            {/* upi id */}
                            {Boolean(isRazorPayPayoutActive) &&
                              type == 'upi' && (
                                <div className='mt-5'>
                                  <div>
                                    <label
                                      htmlFor='username '
                                      className='mr-5 commaon_label'
                                      style={{ color: '#d28d01' }}
                                    >
                                      <i className='far fa-user mr-2'></i>
                                      Account holder name (खाता धारक का नाम) :
                                    </label>
                                    <div className='col-12 mb-3 p-0'>
                                      <input
                                        type='text'
                                        className='form-control commaon_input_box'
                                        id='account_no'
                                        placeholder='Enter Account Name'
                                        name='ifsc'
                                        value={holder_name}
                                        onChange={e =>
                                          setHolder_name(e.target.value)
                                        }
                                        required
                                      />
                                    </div>
                                  </div>

                                  <label
                                    htmlFor='username '
                                    className='mr-5 commaon_label'
                                    style={{ color: '#d28d01' }}
                                  >
                                    <i className='far fa-bank mr-2'></i>UPI ID
                                    (UPI आईडी) || EX. (9999999999@xyz)
                                  </label>
                                  <div className='col-12 mb-3 p-0'>
                                    <input
                                      type='text'
                                      className='form-control commaon_input_box'
                                      id='account_no'
                                      placeholder='Enter Your UPI ID Ex.(9999999999@xyz)'
                                      name='ifsc'
                                      value={upi_id}
                                      onChange={e =>
                                        setUpi_id(e.target.value)
                                      }
                                    />
                                  </div>

                                  <label
                                    htmlFor='username '
                                    className='mr-5 commaon_label'
                                    style={{ color: '#d28d01' }}
                                  >
                                    <i className='far fa-bank mr-2'></i>{' '}
                                    Confirm UPI ID: (कन्फर्म UPI आईडी) || EX.
                                    (9999999999@xyz)
                                  </label>
                                  <div className='col-12 mb-3 p-0'>
                                    <input
                                      type='text'
                                      className='form-control commaon_input_box'
                                      id='account_no'
                                      placeholder='Re Enter Your UPI ID Ex.(9999999999@xyz)'
                                      name='ifsc'
                                      value={confirm_upi_id}
                                      onChange={e =>
                                        setConfirm_upi_id(e.target.value)
                                      }
                                    />
                                  </div>
                                  <small className='text-dark small_para'>
                                    कृपया सही UPI आईडी Ex.(9999999999@xyz)
                                    दर्ज करें।*
                                  </small>
                                </div>
                              )}

                            {/* paytm number */}
                            {Boolean(isRazorPayPayoutActive) &&
                              type == 'paytmransfer' && (
                                <div>
                                  <div>
                                    <label
                                      htmlFor='username '
                                      className='mr-5 commaon_label'
                                      style={{ color: '#d28d01' }}
                                    >
                                      <i className='far fa-user mr-2'></i>
                                      Account holder name (खाता धारक का नाम)
                                    </label>
                                    <div className='col-12 mb-3 p-0'>
                                      <input
                                        type='text'
                                        className='form-control'
                                        id='account_no'
                                        placeholder='Enter Account Name'
                                        name='ifsc'
                                        value={holder_name}
                                        onChange={e =>
                                          setHolder_name(e.target.value)
                                        }
                                        required
                                      />
                                    </div>
                                  </div>

                                  <div>
                                    <label
                                      htmlFor='username '
                                      className='mr-5 commaon_label'
                                      style={{ color: '#d28d01' }}
                                    >
                                      <i className='far fa-bank mr-2'></i>
                                      Paytm number (Paytm नंबर):
                                    </label>
                                    <div className='col-12 mb-3 p-0'>
                                      <input
                                        type='text'
                                        className='form-control'
                                        id='account_no'
                                        placeholder='Enter your Paytm number'
                                        name='upi'
                                        value={paytmNumber}
                                        onChange={e =>
                                          setpaytmNumber(e.target.value)
                                        }
                                      />
                                    </div>
                                    <label
                                      htmlFor='username '
                                      className='mr-5 commaon_label'
                                      style={{ color: '#d28d01' }}
                                    >
                                      <i className='far fa-bank mr-2'></i>{' '}
                                      Confirm Paytm number (कन्फर्म Paytm
                                      नंबर) :
                                    </label>
                                    <div className='col-12 mb-3 p-0'>
                                      <input
                                        type='text'
                                        className='form-control commaon_input_box'
                                        id='account_no'
                                        placeholder='Re Enter Your Paytm Number'
                                        name='ifsc'
                                        value={confirm_account_number}
                                        onChange={e =>
                                          setConfirm_account_number(
                                            e.target.value
                                          )
                                        }
                                      />
                                    </div>
                                  </div>
                                </div>
                              )}

                            {
                              type === "scannerpayment" && <div className="form-group mb-3">
                                <label className="commaon_label">
                                  Upload QR Code
                                </label>
                                <input
                                  type="file"
                                  accept="image/*"
                                  className="form-control"
                                  onChange={(e) => setQrImage(e.target.files[0])}
                                  required
                                />
                              </div>
                            }

                          </div>
                        </div>
                        <div className='px-3'>
                          <label
                            htmlFor='username '
                            className='mr-5 commaon_label'
                            style={{ color: '#d28d01' }}
                          >
                            <img
                              src={
                                '/images/LandingPage_img/global-rupeeIcon.png'
                              }
                              alt=''
                              className='img-fluid'
                              style={{ maxWidth: '20px' }}
                            />{' '}
                            Coin
                          </label>
                        </div>
                        <div className='field col-12 p-0 mt-1 mb-3 px-3'>
                          <input
                            type='phone'
                            className='form-control  search-slt commaon_input_box'
                            name='amount'
                            placeholder='Enter coin'
                            // onChange={(e) => setAmount(e.target.value)}
                            onChange={e => {
                              const value = e.target.value
                              e.target.value = value.replace(/[^\d]/g, '')
                              setAmount(e.target.value)
                            }}
                          />
                        </div>
                        <div
                          className='col-12 p-0 mt-2 pt-3 mr-2'
                          style={{ marginBottom: '100px' }}
                        >
                          {isLoading ? (
                            <div className='pl-2 text-center'>
                              <img
                                src={findGif}
                                style={{ width: '80px', height: '80px' }}
                              />
                            </div>
                          ) : (
                            <button
                              type='button'
                              className=' btn-block btn-sm '
                              id='withdrawcase'
                              style={{
                                height: '40px',
                                backgroundColor: 'rgb(210 141 1)',
                                color: 'white',
                                borderRadius: '21px'
                              }}
                              disabled={Boolean(submitBtn) ? false : true}
                              onClick={() => updateBankDetails()}
                            >
                              WITHDRWAL SUBMIT
                            </button>
                          )}

                          {/* {Boolean(submitBtn) ? "" : "Reload Page"}s */}
                        </div>
                      </div>
                    </div>
                  )}
                </div>
               ): <div className="site_message_main">
                  <p>Please Complete Your Kyc Before Withdraw !</p>
                </div>} 



              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
export default Withdrawopt
